/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {creditNullStateButton} from '../api'

export const useMutationCreditNullStateButton = createReactQueryMutationHook('creditNullStateButton', creditNullStateButton)
